import CrossCurrency from '@/App/tiles/ForwardAccumulator/parts/RightPanel/common/CrossCurrency.tsx';
import FixingReference1 from '@/App/tiles/ForwardAccumulator/parts/RightPanel/common/FixingReference1.tsx';
import FixingReference2 from '@/App/tiles/ForwardAccumulator/parts/RightPanel/common/FixingReference2.tsx';

export const InputGroup4 = () => (
  <>
    <CrossCurrency />
    <FixingReference1 />
    <FixingReference2 />
  </>
);
